import { ApiBaseFront } from '../api-base-front';

// フロント管理
export type MetaShopData = {
  kijshopCd: string,
  version: string,
  isNeedAgreement: boolean,
  surrogateOrder: boolean | null,
  printSetting?: PrintShopMetaSetting,
}

export type PrintShopMetaSetting = {
  layoutPos: 1 | 2 | 3,
  toneCorrection: boolean,
  layoutMargin: boolean,
  autoTrimming: boolean,
  backPrint: boolean,
}

export const INIT_PRINT_SHOP_SETTING: PrintShopMetaSetting = {
  layoutPos: 1,
  toneCorrection: true,
  autoTrimming: false,
  backPrint: false,
  layoutMargin: false,
}
export type MetaShopDataResponse = {
  kijshopCd?: string,
  version?: string,
  isNeedAgreement: 'true' | 'false',
  surrogateOrder: 'true' | 'false' | 'null',
  printSetting?: string,
}


export class ApiGetMetaShop extends ApiBaseFront<MetaShopDataResponse> {
  constructor(kijshopCd: string) {
    super(
      'GET',
      `/api/v1/meta/shop/${kijshopCd}`,
      'JSON',
      {},
    );
  }
}

export class ApiPostMetaShop extends ApiBaseFront<any> {
  constructor(kijshopCd: string, param: MetaShopData) {
    super(
      'POST',
      `/api/v1/meta/shop/${kijshopCd}`,
      'JSON',
      {
        data: {
          kijshopCd: param.kijshopCd,
          version: param.version,
          isNeedAgreement: String(param.isNeedAgreement),
          surrogateOrder: String(param.surrogateOrder),
          printSetting: JSON.stringify(param.printSetting),
        }
      },
    );
  }
  test = (param: MetaShopData) => {
    const isNeedAgreement = param.isNeedAgreement;
    const surrogateOrder = param.surrogateOrder;
    return {
      isNeedAgreement: isNeedAgreement,
      surrogateOrder: surrogateOrder,
    };
  };

}